export enum PostMessageAction {
  NAVIGATE = 'navigate',
  LOADING_START = 'loading_start',
  LOADING_END = 'loading_end',
}